export default __webpack_public_path__ + "fonts/6f1df265692b12c309d2e44fda5a6007.svg";